module.exports = __webpack_public_path__ + "img/简易编辑.4fe1c1d6.gif";